import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable()
export class KiwiHrPromoAnalytics extends AnalyticsBase {
  public readonly namespace = 'KiwiPromo';
  public readonly requireViewContext = true;

  public trackBannerDisplay(): void {
    this.track('BannerDisplayed');
  }

  public trackBannerCtaClick(): void {
    this.track('BannerCTAClicked');
  }

  public trackBannerClose(): void {
    this.track('BannerClosed');
  }
}
